/* eslint-disable */
import {
  Button,
  Checkbox,
  Flex,
  Popover,
  Radio,
  Space,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import "./component/index.css";
import {
  CaretDownOutlined,
  PlusOutlined,
  OneToOneOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import MainTable from "./component/MainTable";
import commonFn from "@/utils/commonFn";
export default function UserList() {
  // 默认选中的值
  const [selectedItems, setSelectedItems] = useState([]);
  const [options, setOptions] = useState([]);
  const [columns, setColumns] = useState([]);
  const [delList, setDelList] = useState([]);
  const [loading, setLoading] = useState(true);
  const childRef = useRef(); // 创建一个 ref 来引用子组件实例
  const CustomIcon = ({ src, alt = 'icon', className = '', style = {} }) => (
  <img 
    src={src} 
    alt={alt} 
    className={`custom-icon ${className}`} 
    style={{ width: '16px', height: '16px', marginRight: '8px', ...style }} 
  />
);

  // 定义父组件方法，用于更新父组件的状态

  const deleteNum = (num) => {
    console.log(num);
    setDelList(num);
  };
  //调用子组件showModal方法
  const showModalAdd = () => {
    if (childRef.current) {
        childRef.current.showModalAdd();
    }
  };
  const showModalThree = () => {
    console.log("==========刷新按钮============");
   if (childRef.current) {
      childRef.current.newListFun();
    }
  };
 

  // 处理选项变化
  const handleChange = (checkedValues) => {
    console.log(checkedValues);
    setSelectedItems(checkedValues);
    if (childRef.current) {
      childRef.current.toggleColumnVisibility(checkedValues);
    }
  };
  // Popover 的内容
  const content = (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <Checkbox.Group
        options={options}
        value={selectedItems}
        className="checkBox"
        onChange={handleChange}
      >
        {/* 使用 Space 的 direction="vertical" 来让复选框垂直排列 */}
        <Space direction="vertical">
          {options.map((option) => (
            <Checkbox key={option.value} value={option.value}>
              {option.label}
            </Checkbox>
          ))}
        </Space>
      </Checkbox.Group>
    </div>
  );
  const content2 = <a>Export to CSV</a>;

  // 获取子组件的值
  const getTableHead = () => {
    const list = childRef.current.getValue();
    setColumns(list);
    const transformedList = list.map((item) => ({
      label: item.dataIndex,
      value: item.key,
    }));
    console.log("columns", columns);
    setOptions(transformedList);
    const transformedList2 = list.map((item) => item.dataIndex);
    setSelectedItems(transformedList2);
  };
  // 使用 useEffect 在页面加载时执行方法
  useEffect(() => {
    console.log("页面加载时执行");
    getTableHead();
  }, []); // 依赖数组为空，确保只在组件首次加载时执行
  return (
    <div>
      <Flex className="topDiv" justify="space-between" align="flex-start">
        <div>
            {commonFn.btnAuthorityFlag('New') && <Space size="large">
         
                           <Button className="btnNew" onClick={showModalAdd}>
             <PlusOutlined />
                New
              </Button>
                    </Space> || null}
        </div>
        <div>
          <Radio.Group defaultValue="a" size="middle">
            <Radio.Button value="a" onClick={showModalThree}>
              <SyncOutlined />
            </Radio.Button>
            <Radio.Button value="b">
              <Popover content={content} title="" trigger="click">
                <OneToOneOutlined />
                <CaretDownOutlined className="ft12" />
              </Popover>
            </Radio.Button>
            {/* <Radio.Button value="c" onClick={DownloadBtn}>
              <Popover title="" trigger="click">
                <VerticalAlignBottomOutlined />
              </Popover>
            </Radio.Button> */}
          </Radio.Group>
        </div>
      </Flex>
      <MainTable ref={childRef} deleteNum={deleteNum} ></MainTable>

    </div>
  );
}
